<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<h2 id="SaveKeyConfirmationDialog" mat-dialog-title>{{fTitle}}</h2>

<mat-dialog-content>
    <p>{{ fParA }}</p>
    <p>{{ fParB }}</p>
    <p>{{ fWarning }}</p>

    <div class="password-copy-container">
        <mat-form-field appearance="outline" color="primary">
            <input matInput [(ngModel)]="password" type="text" readonly>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="copyPassword()">{{ fCopy }}</button>
    </div>

    <div>
        <mat-checkbox [(ngModel)]="confirmed">{{ fConfirm }}</mat-checkbox>
    </div>
</mat-dialog-content>

<div mat-dialog-actions class="button-wrapper">
    <button id="AddOrganizationDialogCancel" mat-raised-button color="primary" (click)="onCancel()" type="button">{{fCancel}}</button>
    <button id="AddOrganizationDialogSave" mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!confirmed" type="button">{{fClose}}</button>
</div>
